import { joinParts } from './utils'

export const receipt = {
  recap: (hash: string) => joinParts('receipts', hash),
}
